import React, { useState, memo, useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { isMobile, isTablet } from "react-device-detect";
import Button from '@material-ui/core/Button';

import { useSpinner } from '../../../../../core/contexts/SpinnerContext';
import { assetListRefreshState } from '../store/AssetsStore';
import AssetListItem from "./AssetListItem";
import * as VehicleApi from "../../../../Common/Apis/VehicleApi";
import SensorAddDialog from '../Dialog/SensorAddDialog';
import { IAsset } from '../store/AssetsStore';

const AssetList = () => {

  const { setSpinner } = useSpinner();

  const [listData, setListData] = useState({ Data: [], Paging: {} });
  const [pageSize, setpageSize] = useState((isMobile && !isTablet) ? 10 : 100);
  const [pageNo, setpageNo] = useState(1);
  const [sortField,] = useState("");
  const [sortOrder,] = useState(2);
  const [sensorLinkItem, setSensorLinkItem] = useState("");

  const assetListRefresh = useRecoilValue(assetListRefreshState);

  const pageSizeChanged = (i: number) => {
    setpageSize(i);
    setpageNo(1);
    getList(1, i, sortField, sortOrder);
  };

  const pageNoChanged = (i: number) => {
    setpageNo(i);
    getList(i, pageSize, sortField, sortOrder);
  };

  const linkSensorClicked = (item: IAsset) => {
    setSensorLinkItem(item.VehicleId);
  };

  const submitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    getList(pageNo, pageSize, sortField, sortOrder);

  };


  const getList = async (_pageNo: number, _pageSize: number, _sortField: string, _sortOrder: number) => {


    setSpinner(true);

    try {

      const resData = await VehicleApi.getVehicleList(_pageNo, _pageSize);

      setListData(resData);

    } catch (err) {
      console.log('err', err);
    }

    setSpinner(false);
  };


  useEffect(() => {
    getList(1, pageSize, sortField, sortOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetListRefresh]);

  return (
    <>
      <div className="row no-gutters">
        <div className="col-lg-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <div className="card">
              <div className="card-body">
                <form onSubmit={submitForm}>
                  <div className="row ">

                    <div className="col-lg-2">
                      <div className="form-group">
                        <Button
                          type="submit"
                          //className=" ml-3"
                          style={{ fontWeight: '600' }}
                          variant="contained"
                          color="primary"
                        >
                          Refresh
                        </Button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            {listData && <AssetListItem
              items={listData.Data}
              paging={listData.Paging}
              pageSizeChanged={pageSizeChanged}
              pageNoChanged={pageNoChanged}
              linkSensorClicked={linkSensorClicked}
            />}

          </div>
        </div>
      </div>
      {
        sensorLinkItem && sensorLinkItem !== "" &&
        <SensorAddDialog
          VehicleId={sensorLinkItem}
          onClose={() => setSensorLinkItem("")}
        />
      }

    </>
  );
};

export default memo(AssetList);